import Layout from "../layouts/LayoutDefault.jsx";
import ContentContainer from "../components/ContentContainer";
import MainContainer from "../components/MainContainer";
import SmallTitleText from "../components/SmallTitleText";
import CreateBlogPostForm from "../components/loggedin/CreateBlogPostForm";

const addAndEditPost = () => {
  return (
    <>
      <Layout
        title="Skriv inlägg"
        description="Skriv ett blogginlägg, eb nyhet eller en recession"
      >
        <MainContainer>
          <ContentContainer>
            <div className="flex justify-between">
              <SmallTitleText text="Skriv inlägg" />
              <a href="/userprofile">
                <button className="btn btn-neutral border border-base-content/20">
                  Tillbaka
                </button>
              </a>
            </div>

            <p className="my-4 max-w-2xl">
              Välj de musikprojekt som inlägget ska bli publicerat av.
              <br />
              <br /> Du kan välja mellan
              <span className="font-bold"> Nyhet</span> eller
              <span className="font-bold"> Blogg</span> som typ av inlägg. Tänk
              på att en <span className="font-bold">nyhet</span> ska innehålla
              något som är aktuellt, såsom ett albumsläpp eller en spelning
              medans ett
              <span className="font-bold"> blogginlägg</span> kan handla om vad
              som helst. Så länge som det rör musikprojekt, t.ex ett inlägg om
              personerna i bandet eller om en dag i inspelningsstudion. <br />
              <br /> Du kan formatera ditt inlägg med verktygen i editorn.
            </p>
            <div className="bg-base-200 border border-base-content/20 rounded-lg p-2 mt-2">
              <CreateBlogPostForm />
            </div>
          </ContentContainer>
        </MainContainer>
      </Layout>
    </>
  );
};

export default addAndEditPost;
